import { render, staticRenderFns } from "./AccordionDST.vue?vue&type=template&id=994a40d4&"
import script from "./AccordionDST.vue?vue&type=script&lang=js&"
export * from "./AccordionDST.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports